export default "__VITE_ASSET__SpINKPu5__"